import {reactive} from 'vue'
import {getUser} from "@/api/user";
import {getCompanies, getCompany, getCompanySettings} from "@/api/company";
import {stores} from "@/data/store";
import {subscription} from "@/data/subscription";

export const user = reactive({
    name: '',
    user_id: '',
    active_company: '',
    companies: [],
    company_info: {},

    async getUserBase() {
        await this.getUserData()
        return {
            name: this.name,
            user_id: this.user_id
        }
    },

    async getUserData() {
        if (!this.user_id) {
            this.user_id = localStorage.getItem('user_id')
        }
        if (!this.name) {
            const user_data = await getUser(this.user_id)
            this.name = user_data.data.name
        }
    },


    async getActiveCompany() {
        if (!this.active_company) {
            const storage_company = localStorage.getItem('active_company')
            if (storage_company) {
                this.setActiveCompany(storage_company, false)
            } else {
                const companies = await this.getUserCompanies()
                if (companies) {
                    this.setActiveCompany(companies[0].id)
                }
            }
        }
        // Загружаем информацию о компании, если её нет или она не соответствует активной компании
        if (!this.company_info.id || this.company_info.id !== this.active_company) {
            await this.loadCompanyInfo()
        }
        return this.active_company
    },

    async getUserCompanies() {
        if (!this.companies.length) {
            const user_companies = await getCompanies()
            this.companies = user_companies.data
        }
        return this.companies
    },

    async getCompanyInfo() {
        if (!this.active_company) {
            await this.getActiveCompany()
            if (!this.active_company){
                return {};
            }
        }
        if (!this.company_info.id || this.company_info.id !== this.active_company) {
            await this.loadCompanyInfo()
        }
        return this.company_info
    },

    // Название и display_id хранятся в ID, налог и часовой пояс - в Profit
    async loadCompanyInfo() {
        const company_id = this.active_company
        const [info, settings] = await Promise.all([
            getCompany(company_id),
            getCompanySettings(company_id),
        ])
        if (company_id === this.active_company) {
            this.company_info = {...settings.data, ...info.data, id: company_id}
        }
        return this.company_info
    },

    setActiveCompany(id, reset = true) {
        this.active_company = id
        localStorage.setItem('active_company', id)
        this.company_info = {} // сбрасываем, чтобы при следующем запросе обновить
        subscription.reset() // сбрасываем данные о подписке при смене компании
        if (reset) {
            stores.resetStores()
        }
    },

    async afterLogout() {
        this.name = ''
        this.user_id = ''
        this.setActiveCompany('')
        this.companies = []
        subscription.reset()
    }
})